import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }

  html, body, #root {
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: 'Noto Sans KR', sans-serif;
    background-color: #0a0a0a;
  }

  body {
    position: fixed;
    overflow: hidden;
    overscroll-behavior: none;
    touch-action: manipulation;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-family: inherit;
    outline: none;
  }

  @media (min-width: 768px) {
    #root {
      max-width: 414px;
      margin: 0 auto;
      border-left: 1px solid #222;
      border-right: 1px solid #222;
      height: 100%;
      position: relative;
    }
  }
`;

export default GlobalStyles;
